import { autoMount } from '../../../utils/autoMount';
import { RecruitmentTerms } from '../../../components/pages/recruitmentTerms';

autoMount({ RecruitmentTerms });
